import React, { useState, useEffect } from "react";
import { makeStyles, TextField, Grid, Container } from "@material-ui/core";
import { Formik, Form, FastField, FieldArray } from "formik";
import { isArray } from "lodash";
import NumberFormat from "react-number-format";
import ButtonWithSpinner from "../ButtonWithSpinner";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  fullWidth: {
    width: "100%",
  },
  textfield: {
    width: "100%",
  },
  row: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  control: {
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(1),
  },
  buttonContainer: {
    textAlign: "right",
    padding: theme.spacing(1),
  },
}));

function SchedulesForm(props) {
  const { initialValues, onSubmit, loading, labelSaveButton } = props;
  const classes = useStyles();

  const withSecondRange = (rows) => rows.map((item) => ({
    ...item,
    startTime: item.startTime || "",
    endTime: item.endTime || "",
    startTime2: item.startTime2 || "",
    endTime2: item.endTime2 || "",
  }));

  const [schedules, setSchedules] = useState([
    { weekday: "Lunes", weekdayEn: "monday", startTime: "", endTime: "", startTime2: "", endTime2: "" },
    { weekday: "Martes", weekdayEn: "tuesday", startTime: "", endTime: "", startTime2: "", endTime2: "" },
    { weekday: "Miércoles", weekdayEn: "wednesday", startTime: "", endTime: "", startTime2: "", endTime2: "" },
    { weekday: "Jueves", weekdayEn: "thursday", startTime: "", endTime: "", startTime2: "", endTime2: "" },
    { weekday: "Viernes", weekdayEn: "friday", startTime: "", endTime: "", startTime2: "", endTime2: "" },
    { weekday: "Sábado", weekdayEn: "saturday", startTime: "", endTime: "", startTime2: "", endTime2: "" },
    { weekday: "Domingo", weekdayEn: "sunday", startTime: "", endTime: "", startTime2: "", endTime2: "" },
  ]);

  useEffect(() => {
    if (isArray(initialValues) && initialValues.length > 0) {
      setSchedules(withSecondRange(initialValues));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValues]);

  const handleSubmit = (data) => {
    onSubmit(data);
  };

  return (
    <Formik
      enableReinitialize
      className={classes.fullWidth}
      initialValues={{ schedules }}
      onSubmit={({ schedules }) =>
        setTimeout(() => {
          handleSubmit(schedules);
        }, 500)
      }
    >
      {({ values }) => (
        <Form className={classes.fullWidth}>
          <FieldArray
            name="schedules"
            render={(arrayHelpers) => (
              <>
              <p style={{ margin: "0 8px 8px", color: "#667", fontSize: 13 }}>{i18n.t("schedules.form.secondHint")}</p>
              <Grid spacing={2} container>
                {values.schedules.map((item, index) => {
                  return (
                      <Container key={`schedule-${index}-${item.weekdayEn || item.weekday}`} style={{ display: "flex", flexWrap: "wrap", gap: 8, alignItems: "center", marginBottom: 4 }}>
                          <FastField
                            component={TextField}
                            label={item.weekday || i18n.t("schedules.form.weekday")}
                            name={`schedules[${index}].weekday`}
                            disabled
                            variant="outlined"
                            style={{ width: 150 }}
                            margin="dense"
                          />
                          <FastField
                            name={`schedules[${index}].startTime`}
                            >
                            {({ field }) => (
                              <NumberFormat
                                label={i18n.t("schedules.form.startTime")}
                                {...field}
                                variant="outlined"
                                margin="dense"
                                customInput={TextField}
                                format="##:##"
                                style={{ width: 120 }}
                              />
                            )}
                          </FastField>
                          <FastField
                            name={`schedules[${index}].endTime`}
                            >
                            {({ field }) => (
                              <NumberFormat
                                label={i18n.t("schedules.form.endTime")}
                                {...field}
                                variant="outlined"
                                margin="dense"
                                customInput={TextField}
                                format="##:##"
                                style={{ width: 120 }}
                              />
                            )}
                          </FastField>
                          <FastField
                            name={`schedules[${index}].startTime2`}
                            >
                            {({ field }) => (
                              <NumberFormat
                                label={i18n.t("schedules.form.startTime2")}
                                {...field}
                                variant="outlined"
                                margin="dense"
                                customInput={TextField}
                                format="##:##"
                                style={{ width: 130 }}
                              />
                            )}
                          </FastField>
                          <FastField
                            name={`schedules[${index}].endTime2`}
                            >
                            {({ field }) => (
                              <NumberFormat
                                label={i18n.t("schedules.form.endTime2")}
                                {...field}
                                variant="outlined"
                                margin="dense"
                                customInput={TextField}
                                format="##:##"
                                style={{ width: 120 }}
                              />
                            )}
                          </FastField>

                      </Container>

                  );
                })}
              </Grid>
              </>
            )}
          ></FieldArray>
          <div style={{ textAlign: "center", marginTop: "2%" }} className={classes.buttonContainer}>
            <ButtonWithSpinner
              loading={loading}
              type="submit"
              color="primary"
              variant="contained"
            >
              {labelSaveButton ?? i18n.t("schedules.form.save")}
            </ButtonWithSpinner>
          </div>
        </Form>
      )}
    </Formik>
  );
}

export default SchedulesForm;
